<template>
  <div class="translation">
    <!-- <div class="selected-language">
      <label>{{ $t('languages.selectLang') }}</label>
      <img v-if="getLanguage === 'en'" src="@/assets/flags/english.png" alt="" width="24" height="24">
      <img v-if="getLanguage === 'es'" src="@/assets/flags/mexico.png" alt="" width="24" height="24">
    </div> -->
    <div class="select-language">
      <div class="title">
        <label>{{ $t('languages.chooseLang') }}:</label>
        <div class="languages">
          <!-- <h2 class="">{{ $t('languages.mxAndUsa') }}</h2> -->
          <div class="list">
            <label
              v-for="language in languages"
              :key="language.value"
              :class="language.value === selected_language ? 'selected' : ''"
              for=""
              @click.prevent="updateLanguage(language)"
            >
              <!-- <img v-if="language.value == selected_language" src="@/assets/tutor/checkAllGreen.png" alt="" width="32" height="32"> -->
              <!-- <img v-if="language.value === 'es'" src="@/assets/flags/mexico.png" alt="" width="32" height="32"> -->
              {{ language.label === 'Spanish' ? 'Español' : 'English' }}
            </label>
          </div>
        </div>
      </div>
    </div>
    <!-- <li class="dropdown">
      <a href="#" class="dropdown-toggle" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false">
      ({{ currentLanguage }}) <span class="caret"></span>
      </a>

      <ul class="dropdown-menu">
        <li v-for="language in languages" v-bind:key="language.label">
          <a href="#" @click.prevent="updateLanguage(language)">
            {{ language.label }}
          </a>
        </li>
      </ul>
    </li> -->
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import moment from 'moment';

export default {
  name: 'LanguageSelector',
  data() {
    return {
      selected_language: '',
      languages: [
        { value: 'es', label: this.$t('languages.es') },
        { value: 'en', label: this.$t('languages.en') },
      ],
    };
  },
  computed: {
    // mix the getters into computed with object spread operator
    ...mapGetters({
      getLanguage: 'app/language', //language
      user: 'userAuthenticated',
    }),
    currentLanguage() {
      return this.languages.filter(language => language.value === this.selected_language)[0].label;
    },
  },
  created() {
    this.selected_language = this.getLanguage;
  },
  methods: {
    ...mapActions(['changeLanguage']),
    updateLanguage(language) {
      this.selected_language = language.value;
      // Se resetea el valor de language con el nuevo valor seleccionado
      this.changeLanguage(this.selected_language); // this.$store.commit('setLanguage', this.selected_language)
      this.$i18n.locale = this.selected_language;
      // Guarda el lenguage seleccionado
      this.saveSelectedLanguage(language.value);
      moment.locale(language.value);
    },
    /** Guarda el lenguage seleccionado en la base de datos */
    saveSelectedLanguage(language) {
      var self = this;
      // console.log(language)
      // console.log(this.selected_language)
      this.$httpMain
        // .post(`save_selected_language`, {
        //   language: language,
        //   prefix: this.selected_language,
        //   token: this.$store.state.cookie,
        // })
        .post(`language`, {
          lang: language,
          //prefix: this.selected_language,
        })
        .then(function (response) {
          if (response.data) {
            self.$toasted.success(self.$t('sidebar.savedSatis'), {
              position: 'bottom-right',
              duration: 2000,
              icon: {
                name: 'check-circle',
              },
            });
          }
        })
        .catch(function (error) {
          if (error) {
            self.$toasted.show(self.$t('messages.ops'), {
              type: 'error',
              position: 'bottom-right',
              duration: 2000,
              icon: {
                name: 'times-circle',
              },
            });
          }
        });

      // this.$httpMain
      //   .post(`save_language_by_user`, {
      //     prefix: this.selected_language,
      //     user_id: this.user.id,
      //   })
      //   .then(function () {
      //     // if (res.data) {
      //     //   self.$toasted.success(self.$t('sidebar.savedSatis'), {
      //     //     position: 'bottom-right',
      //     //     duration: 2000,
      //     //     icon: {
      //     //       name: 'check-circle'
      //     //     }
      //     //   })
      //     // }
      //   })
      //   .catch(function (error) {
      //     if (error) {
      //       // self.$toasted.show(self.$t('messages.ops'), {
      //       //   type: 'error',
      //       //   position: 'bottom-right',
      //       //   duration: 2000,
      //       //   icon: {
      //       //     name: 'times-circle'
      //       //   }
      //       // })
      //     }
      //   });
    },
  },
};
</script>
<style lang="scss" scoped>
.translation {
  width: 100%;
}
.selected-language {
  margin-top: 10px;
  float: right;
  display: flex;
  align-items: center;
  label {
    margin-bottom: 0;
  }
  img {
    margin-left: 15px;
    margin-right: 15px;
  }
}

.select-language {
  .title {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .title label {
    font-weight: bolder;
    font-size: 100%;
    margin: 0;
  }
  .languages {
    background-color: #fff;
    border-radius: 5px;
    h2 {
      font-weight: bolder;
      margin-left: 15px;
      // font-weight
    }
    .list {
      display: flex;
      align-items: center;
      justify-content: space-around;
      label {
        cursor: pointer;
        font-weight: normal;
        margin-bottom: 0;
        display: flex;
        align-items: center;
        &:hover {
          color: rgba(0, 0, 0, 0.5);
        }
        img {
          margin-right: 10px;
        }
        + label {
          margin-left: 20px;
        }
        &.selected {
          font-weight: bolder;
          color: green;
        }
      }
    }
  }
}
</style>
